import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/Article/atoms/CoverPhoto.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/Article/styles/authorIntro.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/Lazy/LazyArticles.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/components/Thumbnail/Thumbnail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DefaultHeadScripts"] */ "/app/src/app/lib/root/scripts.tsx");
